import classnames from 'classnames';

import style from './SelectList.module.scss';

interface SelectListOptionProps {
    isSelected: boolean;
    name: string;
    id?: string;
    onSelect(id?: string): void;
}

export function SelectListOption({ name, id, isSelected, onSelect }: SelectListOptionProps) {
    return (
        <div
            className={classnames([style.option, isSelected && style.option_selected])}
            onClick={() => onSelect(!isSelected ? id : undefined)}
        >
            {name}
        </div>
    );
}
